import type { EmailRecipientStatus } from '../types';
import type { StanBadgeProps } from '@/components/core-components/StanBadge/StanBadge';

/**
 * Get display text for email recipient status
 */
export function getEmailRecipientStatusText(status: EmailRecipientStatus): string {
    switch (status) {
        case 'SEND':
            return 'Sent';
        case 'OPEN':
            return 'Opened';
        case 'CLICK':
            return 'Clicked';
        default:
            return 'Sent';
    }
}

/**
 * Get badge variant for email recipient status
 */
export function getEmailRecipientStatusVariant(status: EmailRecipientStatus): StanBadgeProps['variant'] {
    switch (status) {
        case 'SEND':
            return 'muted';
        case 'OPEN':
            return 'success';
        case 'CLICK':
            return 'primary';
        default:
            return 'muted';
    }
}
